module.exports = __webpack_public_path__ + "static/media/logo_zaat-02.7155d178.svg";